import React from "react";
import {
  MDBCarousel,
  MDBCarouselInner,
  MDBCarouselItem,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBMask,
  MDBIcon,
  MDBView,
} from "mdbreact";
import Project from "../../../components/Project/Project.jsx";
import { Zoom } from "react-reveal";
import getFileData from "../../../APICall/Api.jsx";
import Loading from "../../../components/Loading/Loading.jsx";

class FeaturesPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      url: getFileData,
      mainNews: {},
      mainIndex: 0,
      nPages: 0,
      img: {},
      carouselItems: null,
    };
  }

  getItem(projectList, id) {
    return (
      <MDBCarouselItem itemId={id}>
        {projectList.map((prop, key) => (
          <Project key={key} {...prop} focusNews={this.changeMainNews} />
        ))}
      </MDBCarouselItem>
    );
  }

  getProjects = (projects) => {
    let limit = 3;
    let pages = projects.chunk(limit);
    // eslint-disable-next-line
    this.setState({
      nPages: pages.length,
    });
    return (
      <MDBCarouselInner>
        {pages.map((prop, key) => this.getItem(prop, key + 1))}
      </MDBCarouselInner>
    );
  };

  changeMainNews = (news) => {
    var _img = new Image();
    _img.src = news.foto;
    this.setState({
      mainNews: news,
      mainIndex: this.state.items.map((e) => e.titulli).indexOf(news.titulli),
      img: _img,
    });
  };

  formatText = (text) => {
    let newText = text.split("\n");

    return (
      <div>
        {newText.map((a, i) => (
          <p align="justify">{a}</p>
        ))}
      </div>
    );
  };

  callAPI = (lang) => {
    fetch(`${this.state.url.getFileData}/news${lang.capitalize()}.json`, {
      method: "get",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          var _resSortet = result.news; //result.sort(function(a,b){return a.data - b.data}).reverse();
          var lastNews = _resSortet[this.state.mainIndex];

          var _img = new Image();
          _img.src = lastNews.foto;

          this.setState({
            mainNews: lastNews,
            items: _resSortet,
            img: _img,
            isLoaded: true,
            carouselItems: this.getProjects(_resSortet),
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error: error,
          });
        }
      );
  };

  componentDidMount() {
    this.callAPI(this.props.lang);
  }

  componentWillReceiveProps(newProps) {
    this.callAPI(newProps.lang);
  }

  render() {
    if (this.state.error) {
      return <div>Error: {this.state.error.message}</div>;
    } else if (!this.state.isLoaded) {
      return <Loading />;
    } else {
      return (
        //<Zoom top duration={2000}>
        <MDBCard
          className="my-5 px-5 mx-auto news-cont"
          style={{ fontWeight: 300 }}
        >
          <MDBCardBody style={{ paddingTop: 0 }}>
            <h2 className="h1-responsive font-weight-bold my-5 text-center">
              {this.props.title}
            </h2>
            <MDBRow>
              <MDBCol md="12" lg="6">
                <div className="mb-4">
                  <MDBView hover rounded className="z-depth-1-half mb-4">
                    <Zoom>
                      <img
                        className="img-fluid mx-auto"
                        src={this.state.img.src}
                        alt=""
                        width={
                          this.state.img.width === this.state.img.height
                            ? "50%"
                            : "100%"
                        }
                      />
                    </Zoom>
                    <a>
                      <MDBMask overlay="white-slight" className="waves-light" />
                    </a>
                  </MDBView>
                  <div className="d-flex justify-content-between">
                    <a href="#!" className="deep-orange-text">
                      <h6 className="font-weight-bold" />
                    </a>
                    <p className="font-weight-bold dark-grey-text">
                      <MDBIcon far icon="clock" className="pr-2" />
                      {this.state.mainNews.data}
                    </p>
                  </div>
                  <h3 className="font-weight-bold dark-grey-text mb-3 p-0">
                    <a href="#!">{this.state.mainNews.titulli}</a>
                  </h3>
                  <p className="dark-grey-text mb-lg-0 mb-md-5 mb-4">
                    {this.formatText(this.state.mainNews.teksti)}
                  </p>
                </div>
              </MDBCol>
              <MDBCol md="12" lg="6">
                <MDBCarousel
                  activeItem={1}
                  length={this.state.nPages}
                  slide={true}
                  showControls={true}
                  multiItem
                  testimonial
                >
                  {this.state.carouselItems}
                </MDBCarousel>
              </MDBCol>
            </MDBRow>
          </MDBCardBody>
        </MDBCard>
        //</Zoom >
      );
    }
  }
}

export default FeaturesPage;



// WEBPACK FOOTER //
// ./src/views/Components/Sections/SectionProjects.jsx